import { type NutritionPlanDay } from "@fitness-app/data-models/entities/MealsPlan";

export const reduceToDishes = (day: NutritionPlanDay[]) =>
  day
    .map((mealsDay, dayIndex) =>
      mealsDay.meals
        .map((meal, mealIndex) => ({
          ...meal,
          dayId: mealsDay.id,
          dayIndex,
          mealIndex,
        }))
        .flat(),
    )
    .flat()
    .map((meal) =>
      meal.dishes.map((dish, index) => ({
        ...dish,
        dayId: meal.dayId,
        mealIndex: meal.mealIndex,
        mealId: meal.id,
        dayIndex: meal.dayIndex,
        dishIndex: index,
        mealType: meal.type,
      })),
    )
    .flat();
